import { render, staticRenderFns } from "./wel2.vue?vue&type=template&id=228bcaea&scoped=true"
import script from "./wel2.vue?vue&type=script&lang=js"
export * from "./wel2.vue?vue&type=script&lang=js"
import style0 from "./wel2.vue?vue&type=style&index=0&id=228bcaea&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228bcaea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228bcaea')) {
      api.createRecord('228bcaea', component.options)
    } else {
      api.reload('228bcaea', component.options)
    }
    module.hot.accept("./wel2.vue?vue&type=template&id=228bcaea&scoped=true", function () {
      api.rerender('228bcaea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/wel2.vue"
export default component.exports